import { Box, Button, Typography } from '@mui/material';
import { Dispatch, SetStateAction, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { CampaignContext } from '../../contexts/CampaignContext';
import PreviewSmsPanel from './PreviewSmsPanel';
import { ISmsPanelContent } from '../../interfaces/campaign';
import PreviewMediaGrowth from './PreviewMediaGrowth';
import PreviewWebSiteAd from './PreviewWebSiteAd';

type NotSocialMediaProps = {
	setOpenSmsPanelModal?: Dispatch<SetStateAction<boolean>>;
	setOpenMediaGrowthModal?: Dispatch<SetStateAction<boolean>>;
	setOpenWebsiteAdModal?: Dispatch<SetStateAction<boolean>>;
	openNotSocialPreview?: boolean;
	previewContent?: boolean;
	handleOpenPostModal?: () => void;
	smsContent: ISmsPanelContent | null;
};

const NotSocialMedia: React.FC<NotSocialMediaProps> = ({ setOpenSmsPanelModal = () => {}, previewContent = false, openNotSocialPreview, setOpenMediaGrowthModal = () => {}, smsContent, setOpenWebsiteAdModal = () => {} }) => {
	const { t } = useTranslation();
	const { selectedContentType, selectedPlatform } = useContext(CampaignContext);
	const isPost = selectedContentType === 'post';

	const handleOpenPanelModal = () => {
		switch (selectedPlatform) {
			case 'sms':
				setOpenSmsPanelModal(true);
				break;
			case 'media_growth':
				setOpenMediaGrowthModal(true);
				break;
			case 'website_ad':
				setOpenWebsiteAdModal(true);
				break;
			default:
		}
	};
	return (
		<>
			{openNotSocialPreview && selectedPlatform === 'sms' ? (
				<PreviewSmsPanel smsContent={smsContent} handleOpenPostModal={handleOpenPanelModal} />
			) : openNotSocialPreview && selectedPlatform === 'media_growth' ? (
				<PreviewMediaGrowth smsContent={smsContent} previewContent={previewContent} handleOpenPostModal={handleOpenPanelModal} />
			) : openNotSocialPreview && selectedPlatform === 'website_ad' ? (
				<PreviewWebSiteAd smsContent={smsContent} previewContent={previewContent} handleOpenPostModal={handleOpenPanelModal} />
			) : (
				<Box className="flex h-96 w-80 cursor-pointer flex-col items-center justify-center rounded-3xl border border-dashed border-action-active bg-grey-100 px-10 text-sm text-text-secondary" onClick={handleOpenPanelModal}>
					<Typography className="text-center">{isPost ? t('add_post_button_text') : t('add_story_create_button_text')}</Typography>
					<Button className="mt-6 w-full" size="large">
						{selectedPlatform === 'sms' ? t('sms_panel') : selectedPlatform === 'media_growth' ? t('media_growth') : t('website_ad')}{' '}
					</Button>
				</Box>
			)}
		</>
	);
};

export default NotSocialMedia;
